"use client";

import { useEffect, useState } from "react";
import { Button, Card, Input, Popover } from "antd";
import {
  EditOutlined,
  HomeOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import "bootstrap/dist/css/bootstrap.min.css";
import "antd/dist/reset.css";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { useAuth } from "../../services/authentication_API/authService";
import {
  addConsultFee,
  getConsultFee,
} from "../../services/doctor/consultsnt_fees/consultantFee";
import { useMessageApi } from "../../services/message api/MessageProvider";

export default function ConsultationFeeComponent() {
  const [consultationFees, setConsultationFees] = useState([
    { type: "New Consult", fee: 50 },
  ]);

  const [editingIndex, setEditingIndex] = useState(null);
  const [editFee, setEditFee] = useState(false);
  const { userData } = useAuth();
  const [loading, setLoading] = useState(false);
  const [consultantFeee, setConsultantFee] = useState(null);
  const messageApi = useMessageApi();

  const handleEdit = () => {
    setEditingIndex(true);
  };

  const handleSave1 = () => {
    if (editingIndex !== null) {
      const updatedFees = [...consultationFees];
      updatedFees[editingIndex].fee = editFee;
      setConsultationFees(updatedFees);
      setEditingIndex(null);
    }
  };
  const getConsultFees = async () => {
    try {
      setLoading(true);
      const result = await getConsultFee(userData?.id);
      if (result.success) {
        setLoading(false);
        setConsultantFee(result?.data?.consultantion_fee);
      } else {
        setConsultantFee(null);
      }
    } catch (err) {
      setConsultantFee(null);
    }
  };
  useEffect(() => {
    getConsultFees();
  }, []);

  const handleSave = async () => {
    try {
      const payload = {
        consultantion_fee: consultantFeee,
      };
      const result = await addConsultFee(payload, userData?.id);

      if (result?.success) {
        messageApi.success("Consultant fee added successfully!");
        setConsultantFee(result?.data?.consultantion_fee);
        setEditingIndex(null);
        getConsultFees();
      } else {
        const errors = result?.error;
        Object.entries(errors).forEach(([field, messages]) => {
          const messageArray = Array.isArray(messages) ? messages : [messages];
          messageArray.forEach((msg) => {
            messageApi.error({
              content: `${field}: ${msg}`,
              style: {
                maxWidth: "300px",
                minWidth: "300px",
                textAlign: "left",
                wordBreak: "break-word",
              },
            });
          });
        });
      }
    } catch (error) {
      console.error("Error adding patient:", error?.message);
      messageApi.error("Failed to add patient");
    }
  };

  const handleCancel = () => {
    setEditingIndex(null);
  };

  const feeBreakupContent = (fee) => (
    <div className="fee-breakup-popover">
      <h6 className="mb-3">Fee Breakup:</h6>
      <div className="d-flex justify-content-between mb-2">
        <span className="text-muted">Consultation charged to patient</span>
        <span>₹{fee}</span>
      </div>
      <div className="d-flex justify-content-between mb-2">
        <span className="text-muted">Platform fee (incl. GST)</span>
        <span>₹0</span>
      </div>
      <div className="d-flex justify-content-between mb-2">
        <span className="text-muted">Total deductions</span>
        <span>₹0</span>
      </div>
      <div className="d-flex justify-content-between fw-bold mt-2 pt-2 border-top">
        <span>Your earnings per consultation</span>
        <span>₹{fee}</span>
      </div>
    </div>
  );
  useEffect(() => {
    const sidebar = document.getElementById("sidebar");
    if (sidebar) {
      sidebar.classList.add("sidebar-doctor");
      sidebar.id = "menu-item1"; // Change ID if needed
    }
    document.body.classList.remove("expand-menu");

    document.body.classList.add("mini-sidebar");
  }, []);
  return (
    <div>
      <Sidebar activeClassName="consultantion-fee" />
      <div className="page-wrapper-doctor">
        <div className="content">
          <div className="page-header">
            <b>
              <h3 className="page-title font-weight-bold">Doctor Schedule</h3>
            </b>
          </div>

          <div className="card">
            <div className="card-body d-flex">
              <div className="container mt-4">
                <div className="mb-4">
                  <h3 className=" fw-bold" style={{ color: "#2e37a4" }}>
                    In-Clinic Consultation Fee
                  </h3>
                  <p className="text-muted">
                    Set custom consultation charges based on different
                    consultation type and mode
                  </p>
                </div>
                <Card
                  className="mb-3 border rounded"
                  style={{ maxWidth: "650px" }}
                >
                  {editingIndex ? (
                    // Edit Mode
                    <div className="p-3">
                      <div className="d-flex align-items-center mb-4">
                        <div className="me-3">
                          <HomeOutlined
                            style={{
                              fontSize: "24px",
                              color: "#2e37a4",
                              border: "1px solid #2e37a4",
                              borderRadius: "4px",
                              padding: "8px",
                            }}
                          />
                        </div>
                        <h5 className="mb-0">Consultantion Fee</h5>
                        <div className="ms-auto">
                          <Popover
                            content={feeBreakupContent(editFee)}
                            title={null}
                            trigger="hover"
                            placement="right"
                          >
                            <Button type="text" icon={<InfoCircleOutlined />}>
                              What&apos;s the fee breakup
                            </Button>
                          </Popover>
                        </div>
                      </div>

                      <div className="mb-4">
                        <label className="form-label">Consultation Fee</label>
                        <div className="d-flex align-items-center">
                          <div
                            className="input-group"
                            style={{ maxWidth: "200px" }}
                          >
                            <span className="input-group-text">₹</span>
                            <Input
                              value={consultantFeee}
                              onChange={(e) => setConsultantFee(e.target.value)}
                              type="number"
                              min={0}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex mt-4">
                        <Button className="me-2" onClick={handleCancel}>
                          Cancel
                        </Button>
                        <Button type="primary" onClick={handleSave}>
                          Save
                        </Button>
                      </div>
                    </div>
                  ) : (
                    // View Mode
                    <div className="p-3 d-flex align-items-center">
                      <div className="me-3">
                        <HomeOutlined
                          style={{
                            fontSize: "24px",
                            color: "#2e37a4",
                            border: "1px solid #2e37a4",
                            borderRadius: "4px",
                            padding: "8px",
                          }}
                        />
                      </div>
                      <div>
                        <h5 className="mb-0">Consultation Fee</h5>
                        <div className="fw-bold" style={{ color: "#2e37a4" }}>
                          ₹{consultantFeee} per consult
                        </div>
                      </div>
                      <div className="ms-auto">
                        <Button
                          type="text"
                          icon={<EditOutlined />}
                          onClick={() => handleEdit()}
                          aria-label="Edit consultation fee"
                        />
                      </div>
                    </div>
                  )}
                </Card>
                )
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
